import clsx from 'clsx';

import { CharacterTagTypesEnum } from '@data/charactersTags';

import styles from './Tag.module.css';

const tagIdToVariantMap = {
  [CharacterTagTypesEnum.SafeFlirt]: styles.safeFlirt,
  [CharacterTagTypesEnum.NSFW]: styles.nsfw,
  [CharacterTagTypesEnum.Realistic]: styles.realistic,
  [CharacterTagTypesEnum.BDSM]: styles.bdsm,
  [CharacterTagTypesEnum.Roleplay]: styles.roleplay,
  [CharacterTagTypesEnum.Bold]: styles.bold,
  [CharacterTagTypesEnum.Shy]: styles.shy,
  [CharacterTagTypesEnum.Adventure]: styles.adventure,
  [CharacterTagTypesEnum.Image_generation]: styles.imgGen,
};

export default function Tag({ id, name }) {
  return <div className={clsx(styles.tag, tagIdToVariantMap[id])}>{name}</div>;
}
